<div *ngIf="reportType == 'InDetail-Officer'">
  <div class="container mt-4" id="print-section" style="font-size: 12px; color: #000;">
    <table class="table table-bordered" style="border-collapse: collapse; width: 100%;">
      <thead>
        <tr>
          <th colspan="3" style="text-align: left;">Vivek Saptahik</th>
          <th colspan="6" style="text-align: center;">Issue Seller Payment Receipt Ledger</th>
          <th colspan="3" style="text-align: right;">Date</th>
        </tr>
        <tr>
          <th colspan="3" style="text-align: left;">Office Representative-wise</th>
          <th colspan="6" style="text-align: center;">In Details</th>
          <th colspan="1" style="text-align: center;">
            From: {{startDate | date: 'dd-MM-yyyy'}} To: {{endDate | date: 'dd-MM-yyyy'}}
          </th>
          <th colspan="2" style="text-align: right;">Page No</th>
        </tr>
        <tr>
          <th>Receipt No</th>
          <th>Receipt Date</th>
          <th>Entry Date</th>
          <th>Issue Seller Name</th>
          <th>Representative Name</th>
          <th>Office Representative</th>
          <th>Issue Name</th>
          <th>Issue Date</th>
          <th>Invoice No</th>
          <th>Invoice Date</th>
          <th>Invoice Net Amount</th>
          <th>Received Amount</th>
        </tr>
      </thead>

      <tbody>
        <ng-container *ngFor="let data of PaymentadvtOffInDFormBenas">
          <tr>
            <td colspan="12" style="font-weight: bold; background-color: #f0f0f0;">
              Office Representative: {{ data.off_rep_name }}
            </td>
          </tr>

          <ng-container *ngFor="let repData of data.rep_data">
            <tr>
              <td colspan="10" style="font-weight: bold;">Representative:{{ repData.rep_name }}</td>
              <td colspan="2" style="text-align: end; font-weight: bold;">
                <!-- {{ repData.rep_total }} -->
              </td>
            </tr>

            <tr *ngFor="let advtData of repData.issue_data">
              <td>{{ advtData.rcpt_no }}</td>
              <td>{{ advtData.rcpt_date }}</td>
              <td>{{ advtData.entry_date }}</td>
              <td>{{ advtData.issue_seller_name }}</td>
              <td>{{ advtData.rep_name }}</td>
              <td>{{ data.off_rep_name }}</td>
              <td>{{ advtData.DS_ISSUENAME }}</td>
              <td>{{ advtData.DS_ISSUEDATE }}</td>
              <td>{{ advtData.issue_invoice_no }}</td>
              <td>{{ advtData.issue_invoice_date }}</td>
              <td style="text-align: end;">{{ advtData.net_amt }}</td>
              <td style="text-align: end;">{{ advtData.rcv_amt }}</td>
            </tr>

            <tr>
              <td colspan="10" style="text-align: right;">Rep Total:</td>
              <td  style="text-align: end; font-weight: bold;">{{ repData.rep_net_total }}</td>
               <td style="text-align: end; font-weight: bold;">{{ repData.rep_total }}</td>
            </tr>
          </ng-container>

          <tr>
            <td colspan="10" style="text-align: right;">Office Total:</td>
            <td  style="text-align: end; font-weight: bold;">{{ data.total }}</td>
             <td  style="text-align: end; font-weight: bold;">{{ data.net_total }}</td>
          </tr>
        </ng-container>
      </tbody>

      <tfoot>
        <tr>
          <td colspan="10" style="font-weight: bold; text-align: right;">Grand Total:</td>
          <td  style="font-weight: bold; text-align: end;">
            {{ PaymentadvtOffInDTotal3 | number:'1.2-2' }}
          </td>
           <td  style="font-weight: bold; text-align: end;">
            {{ PaymentadvtOffInDTotal2 | number:'1.2-2' }}
          </td>
        </tr>
      </tfoot>
    </table>
  </div>

  <div style="text-align: right; margin: 20px 50px 20px 0;">
    <button
      class="noPrint"
      style="margin-right: 10px;"
      (click)="exportExcel('Payment_Receipt_Reg_InDetails_officer_Report')"
      mat-raised-button
      color="primary"
    >
      Export
    </button>

    <button
      class="noPrint"
      style="margin-right: 10px;"
      printSectionId="print-section"
      ngxPrint
      [useExistingCss]="true"
      mat-raised-button
      color="primary"
    >
      Print
    </button>

    <button class="noPrint" mat-button mat-dialog-close>Close</button>
  </div>
</div>
